import { createContext, useContext } from "react";

/**
 * Sidebar Context
 * Provides sidebar collapsed state (persisted via LocalStorage adapter)
 */
export interface SidebarContextValue {
  collapsed: boolean;
  setCollapsed: (value: boolean) => void;
}

export const SidebarContext = createContext<SidebarContextValue | null>(null);

/**
 * Hook to access sidebar state from context
 * @returns Sidebar collapsed state and setter
 * @throws Error if used outside SidebarProvider
 */
export const useSidebarContext = (): SidebarContextValue => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebarContext must be used within SidebarProvider");
  }
  return context;
};
